import React from 'react';
import { Link } from 'react-router-dom';
import { bool, string } from 'prop-types';
import { Button } from 'htlib-copy';

import { usePostSingleMissionChecks } from 'hooks/checks';

import AsyncUI from 'components/AsyncUI';

import './ActionsCell.scss';

export default function ActionsCell({ missionId, hasChecks, updateOngoing }) {
  const postSingleMissionChecksMutation = usePostSingleMissionChecks(missionId);

  return hasChecks ? (
    <div className="ActionsCell">
      <Link to={`/missions/${missionId}`}>
        <Button type="primary">Resume</Button>
      </Link>
      <AsyncUI query={postSingleMissionChecksMutation}>
        <Button
          onClick={() => {
            postSingleMissionChecksMutation.mutate();
          }}
          type="primary"
          ghost
          disabled={updateOngoing}
        >
          Refresh
        </Button>
      </AsyncUI>
    </div>
  ) : (
    <div className="ActionsCell">
      <AsyncUI query={postSingleMissionChecksMutation}>
        <Button
          onClick={() => {
            postSingleMissionChecksMutation.mutate();
          }}
          type="gold"
        >
          Check
        </Button>
      </AsyncUI>
    </div>
  );
}

ActionsCell.propTypes = {
  missionId: string.isRequired,
  hasChecks: bool.isRequired,
  updateOngoing: bool.isRequired,
};
